import search from "./search.png";
import addCircle from "./add-circle.png";
import fileExport from "./file-export.png";
import pencilEdit from "./pencil-edit.png";
import printIcon from "./printer.png";
import calendarIcon from "./calendar.png";
import check1Icon from "./check-1.png";
import deleteIcon from "./delete-2.png";
import noDataIcon from "./no-data.png";
import calendar03Icon from "./calendar-03.png";
import arrowReloadIcon from "./arrow-reload-horizontal.png";
import uploadIcon from "./uploadIcon.png";
import exportIcon from "./export.png";
import fileUpload from "./fileUpload.png";

export const Icons = {
  search,
  addCircle,
  fileExport,
  pencilEdit,
  printIcon,
  calendarIcon,
  check1Icon,
  deleteIcon,
  noDataIcon,
  calendar03Icon,
  arrowReloadIcon,
  uploadIcon,
  exportIcon,
  fileUpload,
};
